import React from 'react'
import { IconProps } from '../../../common/types'

const MentoringIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0026 37.1151L16.6693 27.1151H3.33594L6.66927 37.1151H20.0026ZM20.0026 37.1151H26.6693M20.0026 22.1151V21.2817C20.0026 18.1384 20.0026 16.5684 19.0259 15.5917C18.0493 14.6151 16.4793 14.6151 13.3359 14.6151C10.1926 14.6151 8.6226 14.6151 7.64594 15.5917C6.66927 16.5684 6.66927 18.1384 6.66927 21.2817V22.1151M23.3359 29.6151H33.3359C34.22 29.6151 35.0678 29.9663 35.693 30.5914C36.3181 31.2165 36.6693 32.0643 36.6693 32.9484V33.7817C36.6693 34.6658 36.3181 35.5136 35.693 36.1388C35.0678 36.7639 34.22 37.1151 33.3359 37.1151H31.6693M31.6693 22.1151C31.6693 22.9991 31.3181 23.847 30.693 24.4721C30.0678 25.0972 29.22 25.4484 28.3359 25.4484C27.4519 25.4484 26.604 25.0972 25.9789 24.4721C25.3538 23.847 25.0026 22.9991 25.0026 22.1151C25.0026 21.231 25.3538 20.3832 25.9789 19.758C26.604 19.1329 27.4519 18.7817 28.3359 18.7817C29.22 18.7817 30.0678 19.1329 30.693 19.758C31.3181 20.3832 31.6693 21.231 31.6693 22.1151ZM16.6693 7.11507C16.6693 7.99913 16.3181 8.84697 15.693 9.47209C15.0678 10.0972 14.22 10.4484 13.3359 10.4484C12.4519 10.4484 11.604 10.0972 10.9789 9.47209C10.3538 8.84697 10.0026 7.99913 10.0026 7.11507C10.0026 6.23102 10.3538 5.38317 10.9789 4.75805C11.604 4.13293 12.4519 3.78174 13.3359 3.78174C14.22 3.78174 15.0678 4.13293 15.693 4.75805C16.3181 5.38317 16.6693 6.23102 16.6693 7.11507Z"
        stroke="#998D8D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MentoringIcon
